// User Types
export const REGISTER_USER = 'REGISTER_USER'
export const USER_ERROR = 'USER_ERROR'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_AUTHENTICATING = 'SET_AUTHENTICATING'
// Acitivities Types
export const GET_ACTIVITIES = 'GET_ACTIVITIES'
export const GET_ACTIVITIES_FOR_CALENDAR = 'GET_ACTIVITIES_FOR_CALENDAR'
export const GET_ACTIVITY = 'GET_ACTIVITY'
export const GET_ACTIVITY_USER = 'GET_ACTIVITY_USER'
export const GET_ACTIVITIES_PAGINATION = 'GET_ACTIVITIES_PAGINATION'
export const PARSE_ACTIVITY_RUN_METRIC = 'PARSE_ACTIVITY_RUN_METRIC'
export const PARSE_ACTIVITY_RUN_IMPERIAL = 'PARSE_ACTIVITY_RUN_IMPERIAL'
export const PARSE_ACTIVITY_RIDE_METRIC = 'PARSE_ACTIVITY_RIDE_METRIC'
export const PARSE_ACTIVITY_RIDE_IMPERIAL = 'PARSE_ACTIVITY_RIDE_IMPERIAL'
export const SET_UNIT_PREFERENCE = 'SET_UNIT_PREFERENCE'
export const SET_LOADING = 'SET_LOADING'
// Profile Types
export const GET_PROFILE = 'GET_PROFILE'
export const CHANGE_UNIT_PREFERENCE = 'CHANGE_UNIT_PREFERENCE'
export const GET_BIOMETRICS = 'GET_BIOMETRICS'
// Alert Types
export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'
